export default "__VITE_ASSET__CJSR7w1T__"